import { DestroyRef, inject, Injectable } from '@angular/core';
import { MediaListItem } from '../models/media-list-item';

/**
 * Resolves a display URL for a MediaListItem. Caches object URLs created for
 * Files and revokes them when the host injection scope is destroyed.
 *
 * Provide per-component (not root) so cached URLs live as long as the consumer.
 */
@Injectable()
export class MediaItemSourceService {
  private readonly objectUrls = new Map<File, string>();

  constructor() {
    inject(DestroyRef).onDestroy(() => {
      this.objectUrls.forEach((url) => URL.revokeObjectURL(url));
      this.objectUrls.clear();
    });
  }

  sourceOf(item: MediaListItem): string {
    if (item.type === 'media') {
      return item.media.uri ?? '';
    }
    let url = this.objectUrls.get(item.file);
    if (!url) {
      url = URL.createObjectURL(item.file);
      this.objectUrls.set(item.file, url);
    }
    return url;
  }
}
